import { render, staticRenderFns } from "./costData.vue?vue&type=template&id=005961ab&scoped=true&"
import script from "./costData.vue?vue&type=script&lang=js&"
export * from "./costData.vue?vue&type=script&lang=js&"
import style0 from "./costData.vue?vue&type=style&index=0&id=005961ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005961ab",
  null
  
)

export default component.exports